import type { routes } from '@semios/app-platform-banyan-route-definitions'
import type { Contact, Group } from '../../../ContactsAndGroups/ContactsAndGroupsContext'
import type { Report } from '../../_types'

export const convertAPIWeeklyTrapReportToLocalFormat = (
  newReportRaw: NonNullable<
    routes.LegacyWeeklyTrapCatchesReportsManagement.Response['data']['legacyWeeklyTrapCatchesReportsToCreate']
  >[number],
  groupsFromState: Group[],
  contactsFromState: Contact[],
): NonNullable<NonNullable<Report>['weeklyTrapCatches']>[number] => {
  return {
    id: String(newReportRaw.reportId),
    name: newReportRaw.name,
    contacts: Object.values(newReportRaw.contacts).flatMap((c) => {
      const foundCorrespondingContact = contactsFromState.find((cfs) => cfs.id === c.contactId)

      if (!foundCorrespondingContact) return []

      return {
        alertsContactMethods: foundCorrespondingContact.alertsContactMethods,
        email: c.email,
        sms: c.sms,
        groups: foundCorrespondingContact.groups,
        id: c.contactId,
        language: foundCorrespondingContact.language,
        name: c.name,
        reportsContactMethods: foundCorrespondingContact.reportsContactMethods,
      }
    }),
    groups: Object.values(newReportRaw.groups).flatMap((g) => {
      const foundCorrespondingGroup = groupsFromState.find((cfs) => cfs.id === g.groupId)

      if (!foundCorrespondingGroup) return []

      return {
        contacts: foundCorrespondingGroup.contacts,
        id: g.groupId,
        name: g.name,
        alertsContactMethods: foundCorrespondingGroup.alertsContactMethods,
        reportsContactMethods: foundCorrespondingGroup.reportsContactMethods,
      }
    }),
    notifyOwnerByEmail: newReportRaw.notifyOwnerByEmail,
    rules: {
      dayOfWeek: newReportRaw.dayOfWeek,
      startDate: newReportRaw.startDate,
      endDate: newReportRaw.endDate,
      pests:
        newReportRaw.rules?.map((rule) => ({
          insect: rule.insectId,
          startDate: rule.startDate,
          endDate: rule.endDate,
        })) ?? [],
      properties: newReportRaw.propertyIds?.map((propertyId) => ({ id: String(propertyId) })) ?? [],
    },
  }
}
